import { render, staticRenderFns } from "./drugModel_targetGeneBulk.vue?vue&type=template&id=7294df4a&"
import script from "./drugModel_targetGeneBulk.vue?vue&type=script&lang=js&"
export * from "./drugModel_targetGeneBulk.vue?vue&type=script&lang=js&"
import style0 from "./drugModel_targetGeneBulk.vue?vue&type=style&index=0&id=7294df4a&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports